import React, { useState, useEffect } from "react";
import { Input, Button, Spin } from "antd";
import {
  LoadingOutlined,
  CheckOutlined,
  SendOutlined,
} from "@ant-design/icons";
import Fade from "react-reveal/Fade";
import texts from "../../texts.json";
import emailjs from "emailjs-com";

import "./style.css";

const { TextArea } = Input;

const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

const ContactUsComponent = (props) => {
  const [loading, setLoading] = useState(false);
  const [emailSent, setEmailSent] = useState(false);
  const [formName, setFormName] = useState("");
  const [formEmail, setFormEmail] = useState("");
  const [formSubject, setFormSubject] = useState("");
  const [formMessage, setFormMessage] = useState("");
  const index = props.index;

  function sendEmail() {
    setLoading(true);

    const templateParams = {
      subject: formSubject,
      email_from: formEmail,
      name: formName,
      message: formMessage,
    };

    emailjs
      .send(
        "mailjet",
        "template_m3IjNVNz",
        templateParams,
        "user_5of9WtB1DbQFUEWDqVY7V"
      )
      .then(
        (response) => {
          setLoading(false);
          setEmailSent(true);

          clearValues();
        },
        (err) => {
          console.log(err);
          setLoading(false);
        }
      );
  }

  function clearValues() {
    document.getElementById("name-value").value = "";
    document.getElementById("email-value").value = "";
    document.getElementById("subject-value").value = "";
    document.getElementById("message-value").value = "";

    document.getElementById("name-value").setAttribute('disabled', 'true');
    document.getElementById("email-value").setAttribute('disabled', 'true');
    document.getElementById("subject-value").setAttribute('disabled', 'true');
    document.getElementById("message-value").setAttribute('disabled', 'true');
  }

  function validateFields() {
    let flag = true;

    if (formName === "") {
      flag = false;
      document.getElementById("input-name").style.display = "block";
    } else {
      document.getElementById("input-name").style.display = "none";
    }

    if (
      formEmail === "" ||
      !/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(formEmail)
    ) {
      flag = false;
      document.getElementById("input-email").style.display = "block";
    } else {
      document.getElementById("input-email").style.display = "none";
    }

    if (formSubject === "") {
      flag = false;
      document.getElementById("input-subject").style.display = "block";
    } else {
      document.getElementById("input-subject").style.display = "none";
    }

    if (formMessage === "") {
      flag = false;
      document.getElementById("input-message").style.display = "block";
    } else {
      document.getElementById("input-message").style.display = "none";
    }

    if (flag) {
      sendEmail();
    }
  }

  const onNameChanged = (e) => {
    setFormName(e.target.value);
  };

  const onEmailChanged = (e) => {
    setFormEmail(e.target.value);
  };

  const onSubjectChanged = (e) => {
    setFormSubject(e.target.value);
  };

  const onMessageChanged = (e) => {
    setFormMessage(e.target.value);
  };

  return (
    <div className="contact-section section">
      <div className="contact-bg"></div>
      <div className="contact-title section-title" id="contact">
        <div>{texts.titles.contato[index]}</div>
        <Fade left big>
          <div className="line-one-contact"></div>
        </Fade>
        <Fade right big>
          <div className="line-two-contact"></div>
        </Fade>
      </div>

      <div className="section-content">
        <div className="form">
          <div className="one-input">
            <div className="input-title">
              <span style={{ color: "rgb(255, 56, 56)", fontSize: "0.9em" }}>
                *
              </span>{" "}
              {texts.form.nome[index]}:
            </div>
            <Input id="name-value" size="large" onChange={onNameChanged} />
            <div className="required-field" id="input-name">
              Campo Obrigatório!
            </div>
          </div>

          <div className="one-input">
            <div className="input-title">
              <span style={{ color: "rgb(255, 56, 56)", fontSize: "0.9em" }}>
                *
              </span>{" "}
              {texts.form.email[index]}:
            </div>
            <Input id="email-value" size="large" onChange={onEmailChanged} />
            <div className="required-field" id="input-email">
              E-mail inválido!
            </div>
          </div>

          <div className="one-input">
            <div className="input-title">
              <span style={{ color: "rgb(255, 56, 56)", fontSize: "0.9em" }}>
                *
              </span>{" "}
              {texts.form.assunto[index]}:
            </div>
            <Input
              id="subject-value"
              size="large"
              onChange={onSubjectChanged}
            />
            <div className="required-field" id="input-subject">
              Campo Obrigatório!
            </div>
          </div>

          <div className="one-input">
            <div className="input-title">
              <span style={{ color: "rgb(255, 56, 56)", fontSize: "0.9em" }}>
                *
              </span>{" "}
              {texts.form.mensagem[index]}:
            </div>
            <TextArea
              id="message-value"
              rows={6}
              className="message-input"
              size="large"
              onChange={onMessageChanged}
            />
            <div className="required-field" id="input-message">
              Campo Obrigatório!
            </div>
          </div>

          <div className="div-button-submit">
            <Button
              onClick={validateFields}
              className="button-submit"
              type="primary"
              htmlType="submit"
              size="large"
              disabled={loading || emailSent}
            >
              <Spin
                indicator={antIcon}
                className={loading ? "spinner-active" : "spinner"}
              />
              <CheckOutlined
                style={{ display: emailSent ? "inherit" : "none" }}
              />
              &nbsp;&nbsp;
              {loading
                ? texts.form.enviando[index]
                : emailSent
                ? texts.form.enviado[index]
                : texts.form.enviar[index]}
              &nbsp;&nbsp;
              <SendOutlined
                style={{ display: emailSent || loading ? "none" : "inherit" }}
              />
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUsComponent;
